import { OptionPrice } from '../../lib/types/models/option-prices/option-price'
import { OptionPriceInput } from '../../lib/types/models/option-prices/option-price-input'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type OptionPriceRequest = OptionPriceInput & { optionId: number }

export function duplicateOptionPrice(data: IdInput<OptionPriceRequest>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.optionPrices.duplicate.url, { id }))
    .post<OptionPrice, OptionPriceRequest>(rest)
}
